import { render, staticRenderFns } from "./IconBtn.vue?vue&type=template&id=bcaa92e8"
import script from "./IconBtn.vue?vue&type=script&lang=js"
export * from "./IconBtn.vue?vue&type=script&lang=js"
import style0 from "./IconBtn.vue?vue&type=style&index=0&id=bcaa92e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports